import { isTouch } from '../index.js'
import Plyr from 'plyr'
import Hls from 'hls.js'
// const video = require('../video/email.m3u8')

let video

/*
|--------------------------------------------------------------------------
| initVideoPopup
|--------------------------------------------------------------------------
*/

export const initVideoPopup = () => {
  const buttons = document.querySelectorAll('.play_video')
  for (var i = buttons.length - 1; i >= 0; i--) {
    const btn = buttons[i]
    btn.addEventListener('click', function () {
      const videoType = btn.getAttribute('data-video-type')
      const videoID = btn.getAttribute('data-video-id')

      insertPopupHtml(videoType, videoID)
      setTimeout(() => {
        initPopup()
      }, 100)
    })
  }
  // insertPopupHtml('vimeo', '143418951')
  // setTimeout(() => {
  //   initPopup()
  // }, 100)
}

/*
|--------------------------------------------------------------------------
| insertPopupHtml
|--------------------------------------------------------------------------
*/

function insertPopupHtml (videoType, videoID) {
  const htmlString = `<div id="video-popup" class="hidden video_popup d-flex justify-content-center align-items-center">
                        <div class="video-wrapper">
                          <div id="popup-plyr" data-plyr-provider="${videoType}" data-plyr-embed-id="${videoID}"></div>
                          <video id="home-video" autoplay controls playsinline preload="metadata" poster=""></video>
                          <div id="close-video-mobile"></div>
                        </div>
                      </div>`;

  document.body.insertAdjacentHTML( 'beforeend', htmlString );

  video = document.querySelector('#home-video')

  if (video) {
    if (Hls.isSupported()) {
      const hls = new Hls()
      hls.loadSource('../video/email.m3u8')
      hls.attachMedia(video)
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        video.play()
        video.classList.remove('hide')
        video.addEventListener('ended', () => {
          removeVideo()
        });
      })
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = '../video/email.m3u8'
        video.addEventListener('loadedmetadata', () => {
        video.play()
        video.classList.remove('hide')
      })
    }
  }
}

/*
|--------------------------------------------------------------------------
| initPopup
|--------------------------------------------------------------------------
*/

function initPopup() {
  const videoPopup = document.getElementById('video-popup')

  if (!videoPopup)
    return

  videoPopup.classList.add('init')
  setTimeout(() => {
    videoPopup.classList.add('reveal')
  }, 300)

  intiClosePopup(videoPopup)
}

/*
|--------------------------------------------------------------------------
| intiClosePopup
|--------------------------------------------------------------------------
*/

function intiClosePopup(videoPopup) {
  videoPopup.addEventListener('click', (e) => {
    if (e.target.classList.contains('video_popup')) {
      removeVideo()
    }
  })

  document.getElementById('close-video-mobile').addEventListener('click', (e) => {
    removeVideo()
  })
}

/*
|--------------------------------------------------------------------------
| removeVideo
|--------------------------------------------------------------------------
*/

function removeVideo () {
  const videoPopup = document.getElementById('video-popup')
  videoPopup.classList.remove('init')
  setTimeout(() => { videoPopup.remove() }, 500)
}
